import React, {useEffect, useState} from 'react';

import styles from './DesktopCartDelivery.module.css'
import {cn} from "../../../../../utils/cn.ts";
import {Icon} from "../../../../../ui/General/Icon/Icon.tsx";
import {DeliveryCourier} from "../components/DeliveryCourier/DeliveryCourier.tsx";
import {DeliveryPickup} from "../components/DeliveryPickup/DeliveryPickup.tsx";
import {DeliveryByCompanies} from "../components/DeliveryByCompanies/DeliveryByCompanies.tsx";
import {Address, DeliveryType} from "../../../../../types/Delivery.interface.ts";
import {Order} from "../../../../../types/Order.interface.ts";
import {OrderDeliveryType} from "../../../../../utils/getOrderDeliveryType.ts";
import {Button} from "../../../../../ui/General/Button/Button.tsx";

interface Props {
    offer: Order,
    onDeliveryTypeChange: (type: string) => void,
    onDeliveryAddressChange: (address: Address, isUpdate: boolean , changeBranch: boolean, deliveryType: string|null) => void,
    onDeliveryTransportCompanyChange: (transportCompanyId: number) => void,
    setIsBranchShown: (isBranchShown: boolean) => void,
    setIsOpenChangeTownModal: (isOpenChangeTownModal: boolean) => void,
}

export const DesktopCartDelivery: React.FC<Props> = ({
                                                         onDeliveryTypeChange,
                                                         onDeliveryAddressChange,
                                                         onDeliveryTransportCompanyChange,
                                                         offer,
                                                         setIsBranchShown,
                                                         setIsOpenChangeTownModal,
                                                     }) => {
    const city = {id: offer.delivery.townId, name: offer.delivery.townName};
    const [deliveryType, setDeliveryType] = useState(offer.delivery.type);

    const isPodzamenuCourier = deliveryType === DeliveryType.courier;
    const isPodzamenuPickup = deliveryType === DeliveryType.pickup
    const isOthers = deliveryType === DeliveryType.shipping;
    const changeType = (type: string) => {
        onDeliveryTypeChange(type);
        setDeliveryType(type);
    }

    const orderDeliveryType = deliveryType === 'transport_company' ? OrderDeliveryType.transport_company : OrderDeliveryType.in_town;

    useEffect(() => {
        setDeliveryType(offer.delivery.type);
    }, [offer]);
    return (<>
        <h3 className={styles.title}>Где и как вы хотите получить заказ?</h3>
        <div className={styles.wrapper}>
            {
                orderDeliveryType === OrderDeliveryType.transport_company
            ? <>
                        <div className={styles.cityWrapper}>
                            <div className={styles.cityLabel}>Ваш город:</div>
                            <div className={styles.city}>
                                {city.name}
                                {
                                    offer.delivery.company?.alias !== '100_sp'
                                    ? <Button
                                        style={{marginLeft: 8,}}
                                        type='text'
                                        className={styles.deliveryTypeBtnChange}
                                        onClick={() => setIsOpenChangeTownModal(true)}
                                    >
                                        изменить
                                    </Button>
                                    : null
                                }
                            </div>
                        </div>
                    </>
                    : null
            }

            <div className={styles.outline}/>
            <div className={styles.methodsWrapper}>
                <div className={styles.methodsLabel}>
                    Способ доставки:
                </div>
                <ul className={styles.methods}>
                    {
                        orderDeliveryType === OrderDeliveryType.in_town
                            ? <li
                                className={cn(styles.method, isPodzamenuCourier && styles.methodChosen)}
                                onClick={() => changeType(DeliveryType.courier)}
                            >
                                <Icon name='van' width={36} height={30} color={isPodzamenuCourier ? '#F39200' : '#cdcdcd'}/>
                                <div className={styles.type}>
                                    <div className={styles.typeName}>
                                        Доставка курьером
                                    </div>
                                    {
                                        offer.delivery.courierPrice
                                            ? <div className={styles.typeInfo}>
                                                стоимость {offer.delivery.courierPrice} ₽
                                            </div>
                                            : <div className={styles.typeInfo}>
                                                 расчитать стоимость
                                            </div>
                                    }
                                </div>
                            </li>
                            : null
                    }
                    {
                        orderDeliveryType === OrderDeliveryType.in_town
                            ?
                            <li
                                className={cn(styles.method, isPodzamenuPickup && styles.methodChosen)}
                                onClick={() => changeType(DeliveryType.pickup)}
                            >
                                <Icon name='geo-marker' width={23} height={31}
                                      color={isPodzamenuPickup ? '#F39200' : '#cdcdcd'}/>
                                <div className={styles.type}>
                                    <div className={styles.typeName}>
                                        Самовывоз
                                    </div>
                                    <div className={styles.typeInfo}>
                                        {offer.accessibilityBranches.length} ПВ
                                    </div>
                                </div>
                            </li>
                            : null
                    }
                    {
                        orderDeliveryType === OrderDeliveryType.transport_company
                            ?
                            <li
                                className={cn(styles.method, isOthers && styles.methodChosen)}
                                // onClick={() => changeType(DeliveryType.shipping)}
                            >
                                <Icon name='box' width={23} height={31} color={isOthers ? '#F39200' : '#cdcdcd'}/>
                                <div className={styles.type}>
                                    <div className={styles.typeName}>
                                        Транспортная компания
                                    </div>
                                </div>
                            </li>
                            : null
                    }
                </ul>
            </div>

            <div className={styles.outline}/>

            {isPodzamenuCourier &&
                <DeliveryCourier offer={offer} onDeliveryAddressChange={onDeliveryAddressChange} />}
            {isPodzamenuPickup && <DeliveryPickup setIsBranchShown={setIsBranchShown} />}
            {isOthers &&
                <DeliveryByCompanies 
                    onDeliveryTransportCompanyChange={onDeliveryTransportCompanyChange}
                    onDeliveryAddressChange={onDeliveryAddressChange}
                />}
        </div>
    </>);
};